import {ContainerModule} from '@yosmanyga/di'
import {AuthenticationFrontendWithEmailStartController, AuthenticationFrontendWithEmailCompleteController} from './email'
import {AuthenticationFrontendWithFacebookController} from './facebook'
import {AuthenticationFrontendAsGuestController} from './guest'
// import {AuthenticationFrontendWithPhoneCompleteController, AuthenticationFrontendWithPhoneStartController,} from './phone'
import {AuthenticationFrontendFrontController} from './AuthenticationFrontendFrontController'

const DI = new ContainerModule((bind) => {
    bind(AuthenticationFrontendWithEmailStartController).toSelf()
    bind(AuthenticationFrontendWithEmailCompleteController).toSelf()
    bind(AuthenticationFrontendWithFacebookController).toSelf()
    bind(AuthenticationFrontendAsGuestController).toSelf()
    // bind(AuthenticationFrontendWithPhoneCompleteController).toSelf()
    // bind(AuthenticationFrontendWithPhoneStartController).toSelf()
    bind(AuthenticationFrontendFrontController).toSelf()
})

export {
    DI
}
